import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfImage = ({ data }: Props) => {
  const { src } = data;
  const { alt } = data;

  return <img src={src} alt={alt} className="w-max" />;
};
